import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import React, { useEffect, useState } from 'react'
import { LoaderProps } from './types'
import { GET_MERCHANT_BY_ID, GET_MEMBER_MERCHANT_BY_ID } from 'router/queries'
import { isAdmin, signOut, useSession } from 'packages/@slerp/accounts'
import { useLazyQuery } from '@apollo/client'
import { Merchant } from '@slerp/controls'
import isEmpty from 'lodash/isEmpty'

export const MerchantLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant, user } = useSession()
  const { merchantData, setMerchantData, setRefetchMerchantData } =
    useMerchant()

  const [isLoaded, setIsLoaded] = useState(false)

  const adminUser = isAdmin(user)
  const query = adminUser ? GET_MERCHANT_BY_ID : GET_MEMBER_MERCHANT_BY_ID

  const [getMerchant, { data, loading, refetch, error }] = useLazyQuery<{
    merchants_by_pk: Merchant
  }>(query, {
    variables: { merchantId: merchant?.id }
  })

  // Check JWT validity. If invalid, sign out.
  useEffect(() => {
    if (error?.graphQLErrors) {
      const [err] = error.graphQLErrors
      if (err && err?.extensions?.code === 'invalid-jwt') {
        signOut()
      }
    }
  }, [error?.graphQLErrors])

  useEffect(() => {
    if (!merchant?.id || !isEmpty(merchantData)) {
      return
    }

    getMerchant()
  }, [merchant?.id])

  useEffect(() => {
    if (!refetch) {
      return
    }

    setRefetchMerchantData(() => refetch)
  }, [refetch])

  useEffect(() => {
    if (data?.merchants_by_pk) {
      setMerchantData(data.merchants_by_pk)
    }
  }, [data])

  useEffect(() => {
    const hasData = !isEmpty(merchantData)
    setIsLoaded(isParentLoaded && hasData && !loading)
  }, [loading, isParentLoaded, merchantData])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
